import React, { useEffect, useState } from "react";
import * as CronofyElements from "cronofy-elements";

export const CalendarSync = ({ options }) => {
  const [element, setElement] = useState(null);

  useEffect(() => {
    if (!element) {
      setElement(CronofyElements.CalendarSync({ ...options }));
    }
  }, []);

  useEffect(() => {
    if (element) {
      element.update({ ...options });
    }
  }, [options]);

  return <div id="calendar-sync" />;
};
